/**
 * Leave module routes
 */

import { Routes, Route } from 'react-router-dom'
import LeaveBalancePage from './pages/LeaveBalancePage'
import LeaveRequestsPage from './pages/LeaveRequestsPage'
import LeaveRequestDetailPage from './pages/LeaveRequestDetailPage'
import NewLeaveRequestPage from './pages/NewLeaveRequestPage'
import ApproveLeaveRequestsPage from './pages/ApproveLeaveRequestsPage'
import LeaveCalendarPage from './pages/LeaveCalendarPage'
import LeaveManagementPage from './pages/LeaveManagementPage'
import LeaveBalanceEditPage from './pages/LeaveBalanceEditPage'
import LeaveTypesManagementPage from './pages/LeaveTypesManagementPage'
import PublicHolidaysPage from './pages/PublicHolidaysPage'
import LeaveReportPage from './pages/LeaveReportPage'

const LeaveRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LeaveRequestsPage />} />
      <Route path="/requests" element={<LeaveRequestsPage />} />
      <Route path="/requests/:id" element={<LeaveRequestDetailPage />} />
      <Route path="/new" element={<NewLeaveRequestPage />} />
      <Route path="/balance" element={<LeaveBalancePage />} />
      <Route path="/approve" element={<ApproveLeaveRequestsPage />} />
      <Route path="/calendar" element={<LeaveCalendarPage />} />
      <Route path="/manage" element={<LeaveManagementPage />} />
      <Route path="/manage/:userId" element={<LeaveBalanceEditPage />} />
      <Route path="/types" element={<LeaveTypesManagementPage />} />
      <Route path="/holidays" element={<PublicHolidaysPage />} />
      <Route path="/reports" element={<LeaveReportPage />} />
    </Routes>
  )
}

export default LeaveRoutes
